import { render, staticRenderFns } from "./listOf.vue?vue&type=template&id=2d3de874&scoped=true&"
import script from "./listOf.vue?vue&type=script&lang=js&"
export * from "./listOf.vue?vue&type=script&lang=js&"
import style0 from "./listOf.vue?vue&type=style&index=0&id=2d3de874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3de874",
  null
  
)

export default component.exports